<div class="preloader">
    <div class="preloader-progress">
        <div class="whirl standard spinnermargin"></div>
        <div class="preloader-progress-bar"></div>
    </div>
</div>